import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-accounts",
  "use": "icon-soc-l1-accounts-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-accounts\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M352 224a160 160 0 1 1 0 320 160 160 0 0 1 0-320zm0 384c128 0 320 64 320 160v64H32v-64c0-96 192-160 320-160z\" />\r\n  <path d=\"M672 288h224v64H672V288zm0 128h192v64H672v-64zm0 128h160v64H672v-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-accounts.svg
// module id = 9omZ
// module chunks = 534